module.exports = {"TXTCLI_My_Scheduled_Tournaments":{"id":"TXTCLI_My_Scheduled_Tournaments","defaultMessage":"Meine geplanten Turniere"}}